export const getTouch = (e, refs) => {
    let found=undefined;
    if (!Array.isArray(refs)) {
        refs = [refs];
    }
    refs = refs.map(x => x.current);
    for (let i=0; i < e.touches.length; i++) {
        if (refs.includes(e.touches[i].target)) { 
            found = e.touches[i];
            break;
        }
    }
    return found;
};

